import { Form, Select } from 'antd';
import React, { FC, useEffect, useMemo } from 'react';
import { useLazyGetFaqCategoryQuery } from 'app/services/edpApiV1/faq';
import { DEFAULT_CATEGORY_NAME, DEFAULT_CATEGORY_VALUE } from 'shared/constants/faq';
import style from './index.module.scss';

type TProps = {
  name: string;
  placeholder: string;
  onSearch: (data: string | null) => void;
};
let page = 1;
const CategoriesFormItem: FC<TProps> = ({ onSearch, name, placeholder }) => {
  const [getCategoriesQuery, { data }] = useLazyGetFaqCategoryQuery();

  const onChange = (data: string | null) => {
    onSearch(data);
  };

  useEffect(() => {
    getCategoriesQuery({ page: 1, size: 10 });
  }, []);

  const options = useMemo(() => {
    if (data?.data) {
      return [
        ...data?.data.map(org => ({ label: org.name, value: org.id })),
        { label: DEFAULT_CATEGORY_NAME, value: DEFAULT_CATEGORY_VALUE },
      ];
    } else {
      return [{ label: DEFAULT_CATEGORY_NAME, value: DEFAULT_CATEGORY_VALUE }];
    }
  }, [data?.data]);

  // ф-ция следит за скролом и отрабатывает как только мы опускаемся до конца списка,
  // летит запрос за новой порцией сотрудников
  const handlePopupScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const { target } = e;
    if (target instanceof HTMLDivElement) {
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        // пока общее колличество сотрудников не привышает того, что находится в стейте делаю запросы
        if (data?.pagination && data.pagination.total > data.data?.length) {
          getCategoriesQuery({
            page: ++page,
            size: 10,
          });
        }
      }
    }
  };

  return (
    <Form.Item name={name} className={style.searchInput}>
      <Select
        onPopupScroll={handlePopupScroll}
        filterOption={false}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
      />
    </Form.Item>
  );
};

export default CategoriesFormItem;
